<template>
  <div>
    <v-text-field
      :error-messages="errorMessages"
      :hint="hint"
      :label="label"
      :prefix="prefix"
      :rules="contextRules"
      :suffix="suffix"
      :type="contextType"
      v-model="contextModel"
      :readonly="readonly"
    >
      <div slot="append-outer" v-if="defaultButton && !readonly">
        <v-tooltip :disabled="buttonTooltip == null" bottom>
          <template #activator="{on}">
            <v-btn :disabled="buttonDisabled" @click="setDefaultValue" text icon v-on="on">
              <v-icon>{{ buttonIcon }}</v-icon>
            </v-btn>
          </template>
          {{ buttonTooltip }}
        </v-tooltip>
      </div>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: "TextFieldWithCopyDefaultButton",
  components: {},
  props: {
    readonly: {
      required: false,
      default: false
    },
    model: {
      required: true
    },
    label: {
      default: null
    },
    hint: {
      default: null
    },
    type: {
      default: null
    },
    errorMessages: {
      default: () => [],
      required: false,
      type: Array
    },
    defaultButton: {
      default: false
    },
    defaultValue: {
      default: null
    },
    buttonTooltip: {
      default: null
    },
    buttonIcon: {
      default: "keyboard_return"
    },
    buttonDisabled: {
      default: false
    },
    rules: {
      default: () => []
    },
    suffix: {
      default: null
    },
    prefix: {
      default: null
    }
  },
  data: () => ({}),
  computed: {
    contextModel: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit("update:model", val);
      }
    },
    contextType() {
      if (this.type === "number") {
        return null;
      }
      return this.type; // disabled bugged in firefox type number, instead of add validation
    },
    contextRules() {
      if (this.type === "number") {
        let rule = [v => !isNaN(v) || this.$t("global.error.notANumber")];
        for (let r of this.rules) {
          rule.push(r);
        }
        return rule;
      }
      return this.rules;
    }
  },
  methods: {
    setDefaultValue() {
      this.contextModel = this.defaultValue;
    }
  }
};
</script>

<style scoped></style>
